module.exports = __webpack_public_path__ + "static/img/model-bg24.9eaf70f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg24.jpg
// module id = mKSD
// module chunks = 0